import React from 'react';
import { useTranslation } from 'react-i18next';
import '../styles/About.css';
import kuseyImg from '../assets/Images/image.png';

const About: React.FC = () => {
  const { t } = useTranslation();
  return (
    <div className="about-page">
      <div className="about-section">
        <h1 className="about-title">{t('about.title')}</h1>
        <div className="about-section-content">
          <div className="about-section-block">
            <h2 className="about-section-title">{t('about.story.title')}</h2>
            <p className="about-text">{t('about.story.content')}</p>
          </div>

          <div className="about-section-block">
            <h2 className="about-section-title">{t('about.mission.title')}</h2>
            <p className="about-text">{t('about.mission.content')}</p>
          </div>

          <div className="about-section-block">
            <h2 className="about-section-title">{t('about.values.title', 'Our Values')}</h2>
            <div className="about-values-grid">
              <div className="about-value-item">
                <h3 className="about-section-subtitle">{t('about.values.quality.title', 'Quality')}</h3>
                <p className="about-text">{t('about.values.quality.content', 'We never compromise on the quality of our materials or craftsmanship. Each piece is crafted with precision and care.')}</p>
              </div>
              <div className="about-value-item">
                <h3 className="about-section-subtitle">{t('about.values.innovation.title', 'Innovation')}</h3>
                <p className="about-text">{t('about.values.innovation.content', 'We constantly explore new techniques and designs to stay at the forefront of jewelry making.')}</p>
              </div>
              <div className="about-value-item">
                <h3 className="about-section-subtitle">{t('about.values.sustainability.title', 'Sustainability')}</h3>
                <p className="about-text">{t('about.values.sustainability.content', 'We are committed to environmentally responsible practices in our production process.')}</p>
              </div>
              <div className="about-value-item">
                <h3 className="about-section-subtitle">{t('about.values.customerSatisfaction.title', 'Customer Satisfaction')}</h3>
                <p className="about-text">{t('about.values.customerSatisfaction.content', 'Your satisfaction is our top priority. We work closely with you to ensure your complete happiness with our products.')}</p>
              </div>
            </div>
          </div>

          <div className="about-section-block">
            <h2 className="about-section-title">{t('about.team.title')}</h2>
            <p className="about-text">{t('about.team.description')}</p>
            <div className="about-team-member" style={{textAlign: 'center', marginTop: '2rem'}}>
              <img src={kuseyImg} alt="Kusey Hroub CEO" style={{maxWidth: '180px', borderRadius: '1rem', margin: '0 auto'}} />
              <div style={{marginTop: '1rem'}}>
                <div style={{color: '#C9A66B', fontWeight: 'bold', fontSize: '1.5rem', letterSpacing: '1px'}}>CEO</div>
                <div style={{color: '#C9A66B', fontWeight: 'bold', fontSize: '2rem', letterSpacing: '1px'}}>Kusey Hroub</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About; 